import locationImage from '../../assets/images/service-location.png';
import trip from '../../assets/images/trip.png';
import bookmark from '../../assets/images/bookmark.png';
import chatbot from '../../assets/images/chatbot.png';
import AR from '../../assets/images/AR.png';
import Explore from '../../components/explore/Explore';
import React, { useState, useEffect, useRef } from 'react';
import placesServices from '../../services/placesServices';
import '../../scss/style/home.scss';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import NavBar from '../../components/nav/NavBar';
import Footer from '../../components/footer/Footer';
import hands from '../../assets/images/hands.png';
import about from '../../assets/images/about.png';
import Loading from '../../components/loading/Loading';
import { useLocation } from 'react-router-dom';

import ReviewSection from '../../components/ReviewSection/ReviewSection';



export default function Home() {
    const [loading, setLoading] = useState(false); // Added loading state
    const aboutRef = useRef(null);
    const location = useLocation();

    useEffect(() => {
        const hash = window.location.hash;
        if (hash === '#about' && aboutRef.current) {
            aboutRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [location]); // This effect handles scrolling when the hash in the URL changes



    const getAccessTokenFromURL = () => {
        const params = new URLSearchParams(window.location.hash.substring(1));
        return params.get('access_token');
    };
    useEffect(() => {
        const accessToken = getAccessTokenFromURL();

        if (accessToken) {
            // Save the access token to local storage
            localStorage.setItem('accessToken', accessToken);

            // Redirect or perform further actions as needed
        }
    }, []);

const [data, setData] = useState([]);
useEffect(() => {
    setLoading(true);
    placesServices.getPopular().then((places) => {
        setData(places);
        // Set loading to false after data is fetched
        setTimeout(() => {
            setLoading(false);
        }, 1000); // Hide loading after 1 second
    }).catch((error) => {
        console.error('Error fetching places:', error);
        // Set loading to false in case of error
        setLoading(false);
    });

}, []);

    const responsive = {
        0: { items: 1 },
        600: { items: 2 },
        1024: { items: 3 },
        1320: { items: 4 },
    };

    return (
        <div>

            <div className="home-page">
                <NavBar />
                <div className='home-page-image-text-container'>
                    <p className='home-page-image-text'>EXPLORING THE WORLD NOW IS EASIER THAN EVER</p>
                    <p className='home-page-image-text-2'>Enjoy our services </p>
                </div>
            </div>

            <div className='outer-explore-and-services-container'>
                <div className='explore-container'>
                    <h1 className='header-text'>Explore our Popular Destinations</h1>
                    {loading ? <Loading /> : <AliceCarousel
                        responsive={responsive}
                        autoPlay
                        autoPlayInterval={1500}
                        infinite
                        disableButtonsControls
                        dotsDisabled={true}
                    >
                        {data.map((item, index) => (
                            <div key={index}>
                                <Explore image={item.images[0]} />
                            </div>
                        ))}
                    </AliceCarousel>}
                </div>
            </div>

            <div className='outer-explore-and-services-container'>
                <div className='services-outer-container'>
                    <h1 className='header-text'>Our Services</h1>
                    <div className='services-inner-container'>
                        <div className='service-box-1 service-boxes-common'>
                            <img src={locationImage} alt='location' />
                            <p>Discover Places Near You</p>
                        </div>
                        <div className='service-box-2 service-boxes-common'>
                            <img src={trip} alt='trip' />
                            <p>Get a trip suggestion</p>
                        </div>
                        <div className='service-box-3 service-boxes-common'>
                            <img src={bookmark} alt='bookmark' />
                            <p>Save your favourite destinations</p>
                        </div>
                        <div className='service-box-4 service-boxes-common'>
                            <img src={chatbot} alt='chatbot' />
                            <p>Try our Chat bot</p>
                        </div>
                        <div className='service-box-5 service-boxes-common'>
                            <img src={AR} alt='AR' />
                            <p>3D Models</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className='outer-downlaod-container'>
                <img src={hands} alt='hands' className='hands-image' />
                <div className='inner-download-container'>
                    <div className='download-texts-container'>
                        <h1 className='download-header-text'>Download Our App Now</h1>
                        <p className='download-description-text'>Discover Hidden Treasures dive into history like never before with our immersive AR feature. Download the app and explore the past today!</p>
                    </div>
                </div>
            </div>

            <div ref={aboutRef} className='outer-about-container'>
                <img src={about} alt='about' className='about-image' />
                <div className='inner-about-container'>
                    <div className='about-texts-container'>
                        <h1 className='about-header-text'>About Us !</h1>
                        <p className='about-description-text'>We are a team of Faculty of Engineering at Ain Shams University who wanted to help people around the world to explore more places and make their journey more enjoyable and easy. </p>
                    </div>
                </div>
            </div>
            <ReviewSection />
            <Footer />
        </div>

    )
}